<script>
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
export default {
  mixins: [Api, Sabit],
  data() {
    return {
      TableData: {},
      FilterAciklama: "",
      FilterKod: "",
      alert: false,
    };
  },
  components: {
    Loader,
  },
  methods: {
    Get() {},
    FilterGet() {
      this.alert = false;
      if (this.FilterAciklama.length > 2 || this.FilterKod.length > 2) {
        let Page = {
          PageNumber: "1",
          PageSize: "99999",
        };
        this.ActionsFilterGet({
          Service: "StrOkasKodlari",
          Page: Page,
          Filter: "&Aciklama=" + this.FilterAciklama + "&Kod=" + this.FilterKod,
        }).then((res) => {
          this.TableData = res.Data;
        });
      } else {
        this.alert = true;
      }
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      scrollable
      id="StrOkasKodlari"
      size="modal-scrollable"
      :title="$t('StrBirimButceHarcamalariTutarlari.StrOkasKodlari.FormTitle')"
      title-class="font-18"
      hide-footer
    >
      <div class="row mb-2">
        <div class="col-sm-4">
          <div class="search-box me-2 mb-2 d-inline-block">
            <div class="position-relative">
              <input
                type="text"
                v-model="FilterKod"
                class="form-control"
                :placeholder="
                  $t(
                    'StrBirimButceHarcamalariTutarlari.StrOkasKodlari.FilterKod'
                  )
                "
              />
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="search-box me-2 mb-2 d-inline-block">
            <div class="position-relative">
              <input
                type="text"
                v-model="FilterAciklama"
                class="form-control"
                :placeholder="
                  $t(
                    'StrBirimButceHarcamalariTutarlari.StrOkasKodlari.FilterAciklama'
                  )
                "
              />
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-primary btn-rounded mb-2 me-2"
              @click="FilterGet()"
            >
              <i class="bx bx-search-alt search-icon"></i>
              {{
                $t("StrBirimButceHarcamalariTutarlari.StrOkasKodlari.Button")
              }}
            </button>
          </div>
        </div>
      </div>

      <b-alert show variant="danger" v-if="alert"
        >Filtreleme Alanları En Az 3 Karakter Olmalıdır.</b-alert
      >
      <div class="table-responsive" v-if="TableData">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th>
                {{
                  $t(
                    "StrBirimButceHarcamalariTutarlari.StrOkasKodlari.Table.Kod"
                  )
                }}
              </th>
              <th>
                {{
                  $t(
                    "StrBirimButceHarcamalariTutarlari.StrOkasKodlari.Table.Aciklama"
                  )
                }}
              </th>
              <th>
                {{
                  $t(
                    "StrBirimButceHarcamalariTutarlari.StrOkasKodlari.Table.Islem"
                  )
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="Data in TableData" :key="Data.Id">
              <th scope="row">
                {{ Data.Kod }}
              </th>
              <td>{{ Data.Aciklama }}</td>
              <td>
                <div
                  class="
                    w-100
                    d-flex
                    justify-content-center
                    align-center
                    items-center
                    justify-content-between
                  "
                >
                  <i
                    class="fas fa-check"
                    @click="
                      $emit('Data', Data), $bvModal.hide('StrOkasKodlari')
                    "
                  ></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>
    </b-modal>
  </Loader>
</template>
